import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

export const Columns = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        display: 'grid',
        gap: theme.space.base,

        [theme.mq.medium]: {
          gridAutoColumns: '1fr',
          gridAutoFlow: 'column',
        },
      }}
      {...props}
    />
  )
}

export const Column = ({ span, ...rest }) => {
  const theme = useTheme()

  return (
    <div
      css={[
        span && {
          [theme.mq.medium]: {
            gridColumn: `span ${span}`,
          },
        },
      ]}
      {...rest}
    />
  )
}

Column.propTypes = {
  span: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
